(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dietxp-calculator-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dietxp-calculator-cards')) {
  customElements.define('dietxp-calculator-cards', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.dx-calculator-cards__rail');
      this.cards = Array.from(this.querySelectorAll('.dx-calculator-cards__item'));
      this.controls = this.querySelector('.dx-calculator-cards__controls');
      if (!this.rail || !this.cards.length || !this.controls) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      this.position = this.querySelector('.dx-calculator-cards__position');
      this.controls.hidden = false;
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (button && !button.disabled) this.move(Number(button.dataset.direction));
      }, options);
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.rail.addEventListener('focusin', event => {
        const card = event.target.closest('.dx-calculator-cards__item');
        if (card) {
          this.rail.scrollTo({ left: card.offsetLeft - this.cards[0].offsetLeft, behavior: 'instant' });
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.rail);
      this.update();
    }
    move(direction) {
      const step = this.cards.length > 1
        ? this.cards[1].offsetLeft - this.cards[0].offsetLeft
        : this.rail.clientWidth;
      this.rail.scrollBy({
        left: direction * step,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    update() {
      const max = this.rail.scrollWidth - this.rail.clientWidth;
      const left = this.rail.scrollLeft;
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= max - 2;
      const edge = this.rail.getBoundingClientRect().left;
      let current = this.cards.findIndex(card => card.getBoundingClientRect().right > edge + 12);
      if (current < 0) current = this.cards.length - 1;
      const label = (current + 1) + ' / ' + this.cards.length;
      if (this.position.textContent !== label) this.position.textContent = label;
    }
    disconnectedCallback() {
      if (this.abort) this.abort.abort();
      if (this.resize) this.resize.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dietxp-product-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dietxp-product-hero')) {
    customElements.define('dietxp-product-hero', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dx-hero__track');
        this.slides = [...this.querySelectorAll('.dx-hero__slide')];
        this.dots = [...this.querySelectorAll('[data-slide]')];
        this.pauseButton = this.querySelector('[data-pause]');
        if (!this.track || this.slides.length < 2) return;
        this.controller = new AbortController();
        const listen = (node, event, handler) => node.addEventListener(event, handler, { signal: this.controller.signal });
        this.index = 0;
        this.paused = false;
        this.hovered = false;
        this.dragging = false;
        this.inView = false;
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 767px)');
        listen(this, 'click', (event) => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-slide')) this.go(Number(button.dataset.slide));
          if (button.hasAttribute('data-direction')) this.go(this.index + Number(button.dataset.direction));
          if (button.hasAttribute('data-pause')) { this.paused = !this.paused; this.syncPlayback(); }
        });
        listen(this.track, 'scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const anchor = this.track.getBoundingClientRect().left + (this.mobile.matches ? 16 : this.track.clientWidth / 2);
            let nearest = 0;
            this.slides.forEach((slide, i) => {
              const rect = slide.getBoundingClientRect();
              const current = this.slides[nearest].getBoundingClientRect();
              const position = this.mobile.matches ? rect.left : rect.left + rect.width / 2;
              const currentPosition = this.mobile.matches ? current.left : current.left + current.width / 2;
              if (Math.abs(position - anchor) < Math.abs(currentPosition - anchor)) nearest = i;
            });
            this.activate(nearest);
          });
        });
        listen(this.track, 'keydown', (event) => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        listen(this, 'pointerenter', (event) => { if (event.pointerType === 'mouse') { this.hovered = true; this.syncPlayback(); } });
        listen(this, 'pointerleave', () => { this.hovered = false; this.syncPlayback(); });
        listen(this.track, 'pointerdown', () => { this.dragging = true; this.syncPlayback(); });
        const release = () => { if (this.dragging) { this.dragging = false; this.syncPlayback(); } };
        listen(window, 'pointerup', release);
        listen(window, 'pointercancel', release);
        listen(this, 'focusin', (event) => {
          const slide = event.target.closest('.dx-hero__slide');
          if (slide) this.go(this.slides.indexOf(slide), 'instant');
          this.syncPlayback();
        });
        listen(this, 'focusout', () => queueMicrotask(() => this.isConnected && this.syncPlayback()));
        listen(document, 'visibilitychange', () => this.syncPlayback());
        listen(this.reduced, 'change', () => this.syncPlayback());
        listen(this.mobile, 'change', () => this.go(this.index, 'instant'));
        listen(document, 'shopify:block:select', (event) => {
          const i = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (i >= 0) { this.paused = true; this.go(i, 'instant'); }
        });
        this.observer = new IntersectionObserver(([entry]) => { this.inView = entry.isIntersecting; this.syncPlayback(); }, { threshold: .25 });
        this.observer.observe(this);
        this.resizeObserver = new ResizeObserver(() => this.go(this.index, 'instant'));
        this.resizeObserver.observe(this.track);
        this.activate(0);
        this.syncPlayback();
      }
      activate(index) {
        this.index = index;
        this.dots.forEach((dot, i) => i === index ? dot.setAttribute('aria-current', 'true') : dot.removeAttribute('aria-current'));
      }
      go(index, behavior) {
        index = (index + this.slides.length) % this.slides.length;
        const target = this.slides[index].getBoundingClientRect();
        const viewport = this.track.getBoundingClientRect();
        const inset = this.mobile.matches ? 16 : (this.track.clientWidth - target.width) / 2;
        this.track.scrollTo({ left: this.track.scrollLeft + target.left - viewport.left - inset, behavior: behavior || (this.reduced.matches ? 'instant' : 'smooth') });
        this.activate(index);
        this.syncPlayback();
      }
      syncPlayback() {
        clearTimeout(this.timer);
        const stopped = this.paused || this.reduced.matches;
        if (this.pauseButton) {
          this.pauseButton.setAttribute('aria-label', stopped ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel);
          this.pauseButton.firstElementChild.textContent = stopped ? '▶' : 'Ⅱ';
          this.pauseButton.hidden = this.reduced.matches;
        }
        if (this.dataset.autoplay !== 'true' || stopped || this.hovered || this.dragging || !this.inView || document.hidden || this.contains(document.activeElement)) return;
        this.timer = setTimeout(() => this.go(this.index + 1), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_mobile"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncDisclosure(details) {
      var summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    function syncHomepageSocials(drawer) {
      var socialSection = drawer.querySelector('[data-dx-mm-socials]');
      var socialLinks = drawer.querySelector('[data-dx-mm-social-links]');
      var homepageSocials = document.querySelector('.dx-footer-social');
      if (!socialSection || !socialLinks || !homepageSocials) return;

      var sourceLinks = homepageSocials.querySelectorAll('a[href]');
      if (!sourceLinks.length) return;

      socialLinks.replaceChildren();
      sourceLinks.forEach(function (sourceLink) {
        var socialLink = sourceLink.cloneNode(true);
        socialLink.classList.add('dx-mm-social-icon');
        socialLinks.appendChild(socialLink);
      });
      socialSection.hidden = false;
    }

    function bindDrawer(drawer) {
      syncHomepageSocials(drawer);
      if (drawer.getAttribute('data-dx-commerce-menu-bound') === 'true') return;
      drawer.setAttribute('data-dx-commerce-menu-bound', 'true');

      var nrgtToggle = drawer.querySelector('[data-dx-mm-nrgt-toggle]');
      var nrgtPanel = drawer.querySelector('[data-dx-mm-nrgt-panel]');
      var nrgtAction = drawer.querySelector('[data-dx-mm-nrgt-action]');

      if (nrgtToggle && nrgtPanel) {
        nrgtToggle.addEventListener('click', function () {
          var shouldOpen = nrgtToggle.getAttribute('aria-expanded') !== 'true';
          nrgtToggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
          nrgtPanel.hidden = !shouldOpen;
          if (nrgtAction) nrgtAction.textContent = shouldOpen ? 'Hide flavours' : 'Choose a flavour';
        });
      }

      drawer.querySelectorAll('[data-dx-mm-disclosure]').forEach(function (details) {
        syncDisclosure(details);
        details.addEventListener('toggle', function () {
          syncDisclosure(details);
        });
      });
    }

    function initDrawers(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('#Drawer-Menu.dx-mobile-menu-commerce').forEach(bindDrawer);
      if (scope.matches && scope.matches('#Drawer-Menu.dx-mobile-menu-commerce')) bindDrawer(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initDrawers(document);
      });
    } else {
      initDrawers(document);
    }

    document.addEventListener('shopify:section:load', function () {
      initDrawers(document);
    });
  }());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__productTabsSectionBound) return;
    window.__productTabsSectionBound = true;

    function renderVideo(scope) {
      const root = scope || document;
      root.querySelectorAll('.video-open-popup:not([data-video-bound])').forEach((videoOpenPopup) => {
        videoOpenPopup.dataset.videoBound = 'true';
        videoOpenPopup.addEventListener('click', function (e) {
          e.preventDefault();
          const videoId = videoOpenPopup.dataset.videoId;
          const videoWrapper = document.querySelector('.video-modal__content-block');
          if (!videoWrapper || !videoId) return;
          videoWrapper.innerHTML = `<iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`;
        });
      });
    }

    function ensureVideoModal() {
      if (document.getElementById('PopupModal-product-tabs-video')) return;
      document.body.insertAdjacentHTML(
        'beforeend',
        `<side-drawer class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden" id="PopupModal-product-tabs-video" data-moved="true">
          <div class="drawer__overlay fixed inset-0 cursor-pointer"></div>
          <div class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup">
            <div class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar">
              <div class="video-modal__content-block">Video</div>
              <button onclick="this.closest('side-drawer').close()" class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute" type="button" aria-label="Close dialog" style="--top: 0.3rem; --right: 0.3rem">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg>
              </button>
            </div>
          </div>
        </side-drawer>`
      );
    }

    function openAccordionTab(tabContent) {
      const section = tabContent.closest('.section-product-tabs');
      if (!section) return;
      section.querySelectorAll('.style-accordion .toggle-title.is-open').forEach((el) => el.classList.remove('is-open'));
      tabContent.querySelector('.toggle-title')?.classList.add('is-open');
    }

    function closeAccordionTab(tabContent) {
      tabContent.querySelector('.toggle-title')?.classList.remove('is-open');
    }

    document.addEventListener('click', function (e) {
      const section = e.target.closest('.section-product-tabs');
      if (!section) return;

      const tabTitle = e.target.closest('.tab-title');
      if (tabTitle && section.contains(tabTitle)) {
        e.preventDefault();
        const tabList = section.querySelector('.tabs-list');
        if (!tabList) return;
        const tabTitles = [...tabList.querySelectorAll('.tab-title')];
        const tabContents = [...section.querySelectorAll('.product-tabs-tab .tabs-content > .tab-content')];
        const index = tabTitles.indexOf(tabTitle);
        if (index === -1 || tabTitle.classList.contains('is-active')) return;
        tabTitles.forEach((t) => t.classList.remove('is-active'));
        tabContents.forEach((c) => c.classList.remove('is-active'));
        tabTitle.classList.add('is-active');
        setTimeout(() => {
          const content = tabContents[index];
          if (!content) return;
          content.classList.add('is-animating', 'is-active');
          content.addEventListener(
            'transitionend',
            function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            },
            { once: true }
          );
        }, 10);
        return;
      }

      const toggleLink = e.target.closest('.toggle-link');
      if (!toggleLink || !section.contains(toggleLink)) return;
      e.preventDefault();

      const toggleTitle = toggleLink.closest('.toggle-title');
      if (!toggleTitle) return;

      const tabTitleText = document.querySelector('.tab-title-text');
      if (tabTitleText) tabTitleText.textContent = toggleLink.textContent;

      const viewContentType = toggleTitle.dataset.viewContent;
      const content = toggleTitle.nextElementSibling;
      if (!content) return;

      if (Shopify?.designMode && section.querySelector('.style-accordion')) return;

      switch (viewContentType) {
        case 'sidebar': {
          const drawerContent = document.querySelector('#Global-Drawer .drawer__wrapper');
          if (drawerContent) {
            drawerContent.innerHTML = '';
            drawerContent.appendChild(content.cloneNode(true));
            renderVideo(drawerContent);
          }
          break;
        }
        case 'popup': {
          const popupContent = document.querySelector('.popup-content-wrapper');
          if (popupContent) {
            popupContent.innerHTML = '';
            popupContent.appendChild(content.cloneNode(true));
            renderVideo(popupContent);
          }
          break;
        }
        default:
          toggleTitle.classList.toggle('is-open');
      }
    });

    if (Shopify?.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        openAccordionTab(tabContent);
      });

      document.addEventListener('shopify:block:deselect', function (e) {
        const tabContent = e.target.closest('.section-product-tabs .tab-content');
        if (!tabContent) return;
        closeAccordionTab(tabContent);
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      ensureVideoModal();
      renderVideo();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
